import { showToast } from "./toastUtils";

type BackgroundExportMessages = {
  success: string;
  error: string;
};

export const runBackgroundExport = (
  job: () => Promise<void>,
  messages: BackgroundExportMessages,
): Promise<void> =>
  job()
    .then(() => {
      showToast(messages.success);
    })
    .catch((e) => {
      console.error(e);
      showToast(messages.error, "error");
      throw e;
    });
